/**
 * ¿El archivo se abre ahora mismo sin cuenta? (D15, auditoría 2026-10-05)
 * «Público» miraba solo el acceso del enlace del archivo: no contaba la carpeta publicada que lo contiene, y un enlace
 * ya caducado seguía diciendo «Público». `enlace` = { access, expires_at } del archivo; `carpeta` = ruta de la carpeta
 * publicada que lo contiene (la calcula el backend en `publico`), o null.
 */
export function estaPublicado(enlace, carpeta, ahora = Date.now()) {
  const caduca = enlace?.expires_at ? new Date(enlace.expires_at).getTime() : null;
  const abierto = enlace?.access === 'anyone' && !(caduca !== null && caduca <= ahora);
  return abierto || !!carpeta;
}
